import { render, staticRenderFns } from "./ActionComfortInstallation.vue?vue&type=template&id=a19a00e0&scoped=true&"
import script from "./ActionComfortInstallation.vue?vue&type=script&lang=js&"
export * from "./ActionComfortInstallation.vue?vue&type=script&lang=js&"
import style0 from "./ActionComfortInstallation.vue?vue&type=style&index=0&id=a19a00e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a00e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VSpacer,VTextarea})
